// SW registration with a safe update-ready flow. Emits a global "ff-sw-update" event
// (detail = registration) when a new worker is waiting. Reload is guarded against loops.
import { track } from "./api";

let refreshing = false;

export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  // Whether this page load was already controlled by a SW. On a first-ever visit this is null,
  // and the SW's clients.claim() will fire controllerchange — we must NOT reload in that case
  // (an unguarded reload wipes in-progress forms, e.g. the registration screen).
  const hadControllerAtStart = !!navigator.serviceWorker.controller;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        if (reg.waiting) emitUpdate(reg);
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              emitUpdate(reg); // a new version is waiting (existing controller present)
            }
          });
        });
      })
      .catch(() => {});

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      // Only reload for a genuine worker update (a controller was already in charge). Skip the
      // first-install claim so new visitors are never reloaded mid-interaction.
      if (refreshing || !hadControllerAtStart) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

function emitUpdate(reg) {
  track("service_worker_update_ready");
  window.dispatchEvent(new CustomEvent("ff-sw-update", { detail: reg }));
}

export function applyUpdate(reg) {
  track("service_worker_update_applied");
  if (reg && reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
}
